const ignoredErrorMessages = [
  'Invalid call to runtime.sendMessage(). Tab not found.',
  'WKWebView API client did not respond to this postMessage',
]

const stackFramePattern = /:\d+:\d+\)?\s*$/

const scriptFileFramePattern = /\.m?js([?#][^:\s)]*)?:\d+:\d+\)?\s*$/

const hasIgnoredMessage = (message: string) =>
  ignoredErrorMessages.some((ignoredMessage) =>
    message.includes(ignoredMessage)
  )

const isFromInjectedScript = (error: unknown) => {
  if (!(error instanceof Error) || !error.stack) {
    return false
  }

  const frames = error.stack
    .split('\n')
    .filter((line) => stackFramePattern.test(line))

  return (
    frames.length > 0 &&
    frames.every((frame) => !scriptFileFramePattern.test(frame))
  )
}

export const isIgnoredError = (error: unknown) => {
  const message = error instanceof Error ? error.message : String(error)

  return hasIgnoredMessage(message) || isFromInjectedScript(error)
}

export const isIgnoredErrorEvent = (
  event: ErrorEvent | PromiseRejectionEvent
) =>
  isIgnoredError(
    'reason' in event ? event.reason : (event.error ?? event.message)
  )
